import { Button } from '@/shared/components/ui/button';
import { ROUTE_PATHS } from '@/shared/constants/routes';
import { Link } from '@tanstack/react-router';

export const NotFound = () => (
  <div className="flex min-h-[60vh] flex-col items-center justify-center gap-3 px-4 text-center">
    <p className="text-lg font-bold text-ink">페이지를 찾을 수 없어요</p>
    <Button asChild>
      <Link to={ROUTE_PATHS.ACCOUNTS}>거래처로 가기</Link>
    </Button>
  </div>
);
